import { convertStorageStringToArray } from '@utils/general'
import type { NavigateFunction } from 'react-router-dom'

const store = window.localStorage

export const getFilterValues = (property: string) => {
  const values = store.getItem(getFilterKey(property))
  return convertStorageStringToArray(values)
}

export const getFilterKey = (property: string) => {
  return `store_monitoring_${property}_filter`
}

export const applyFrontendFilters = (stores: Gravitate.Site[], alertFilters: string | string[], storeFilters = []) => {
  if (!stores) return []
  if (alertFilters.length === 0 && storeFilters.length === 0) return stores
  let filteredStores = [...stores]
  if (alertFilters.length > 0) {
    filteredStores = filteredStores.filter((s) => {
      return s.flags.some((f) => alertFilters.includes(f.name))
    })
  }
  if (storeFilters.length > 0) {
    filteredStores = filteredStores.filter((s) => storeFilters.includes(s.store_number))
  }
  return filteredStores
}

export const getUniqueStoreAlerts = (stores: Gravitate.Site[]) => {
  const alerts = []
  stores.forEach((s) =>
    s.flags.forEach((flag) => {
      if (!alerts.includes(flag.name)) alerts.push(flag.name)
    })
  )
  return alerts
}

export const onSiteArrowClick = (
  back: boolean,
  detailStoreIds: Gravitate.Site[],
  storeId: string,
  navigate: NavigateFunction
) => {
  const index = detailStoreIds?.findIndex((item) => item.id === storeId)
  // get index, navigate to store in list
  if (back && index > 0) {
    navigate(`/site_monitoring/${detailStoreIds[index - 1]?.id}`)
  }
  if (!back && index < detailStoreIds?.length - 1) {
    navigate(`/site_monitoring/${detailStoreIds[index + 1]?.id}`)
  }
}
